import React from "react";
import { Stack, Typography } from "@mui/material";
import { ISmartrrOrderLineItem } from "@smartrr/shared/entities/OrderLineItem";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import truncate from 'lodash/truncate';
import { getProductNameFromVariantId } from "../../../../utils";
import { IPurchasable } from "@smartrr/shared/entities/Purchasable";

interface OrderItemVariantNameProps {
  item: ISmartrrOrderLineItem;
  purchasables: IPurchasable[];
}

export const OrderItemVariantName = ({ item, purchasables }: OrderItemVariantNameProps) => {
  return (
    <Stack spacing="3px">
      {!!item.vnt?.shopifyId && (
        <Typography variant="body1" className={prefixClassName("variant-name")}>
          {truncate(getProductNameFromVariantId(item.vnt.shopifyId, purchasables))}
        </Typography>
      )}
      {item.vnt?.purchasableVariantName !== "Default Title" && (
        <Typography variant="caption1" sx={{ width: "100%" }} className={prefixClassName("product-variant-name")}>
          {truncate(item.vnt?.purchasableVariantName)}
        </Typography>
      )}
    </Stack>
  );
};
